import { useEffect, type ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '../model/auth.store.js';

/**
 * Token yo'q bo'lsa `/login` ga yo'naltiradi. Bu **qulf emas, marshrut**:
 * ma'lumotni himoya qiladigan yagona joy — backend. Bu yerdagi tekshiruv
 * faqat foydalanuvchini keraksiz bo'sh ekrandan qutqaradi.
 */
export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const accessToken = useAuthStore((s) => s.accessToken);
  const navigate = useNavigate();

  useEffect(() => {
    if (accessToken === null) void navigate({ to: '/login', replace: true });
  }, [accessToken, navigate]);

  if (accessToken === null) return null;
  return <>{children}</>;
};
